import { http } from '../api/http';

export interface AdminUser {
  id: string;
  email: string;
}

export interface LoginResponse {
  token: string;
  admin: AdminUser;
}

export const login = async (email: string, password: string) => {
  const res = await http.post<{ success: boolean; data: LoginResponse }>('/admin/login', {
    email,
    password
  });
  const { token } = res.data.data;
  localStorage.setItem('admin_jwt', token);
  return res.data.data;
};

export const logout = () => {
  localStorage.removeItem('admin_jwt');
};

export const isAuthenticated = () => {
  return Boolean(localStorage.getItem('admin_jwt'));
};

